import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { useSweetAlert } from '@/composables/sweetalert';
import { useDateFormat } from '@/composables/dateFormat';
import { ActivityBudgetAction, ActivityBudgetGetter } from '@/store/activityBudget/activityBudget.module';
import { ActivityBudget } from '@/store/activityBudget/activityBudget.model';
import BaseOffcanvasComponent from '@/components/baseOffcanvas/BaseOffcanvas.vue';

export default defineComponent({
  name: 'ActivityBudgetOffcanvasComponent',
  components: {
    BaseOffcanvasComponent
  },
  emits: [
    'edit',
    'deleted'
  ],
  props: {
    activityId: {
      type: Number,
    },
    provinceId: {
      type: Number,
    },
    activityBudgetId: {
      type: Number,
    }
  },
  setup: (props, context) => {
    const store = useStore();
    const swal = useSweetAlert();
    const dateFormat = useDateFormat();
    const activityBudget = computed<ActivityBudget | undefined>(() => store.getters[ActivityBudgetGetter.BY_ID](props.activityBudgetId));
    const activityBudgetOffcanvas = ref<InstanceType<typeof BaseOffcanvasComponent>>();

    // show modal
    const show = () => {
      activityBudgetOffcanvas.value?.show();
    };

    // hide modal
    const hide = () => {
      activityBudgetOffcanvas.value?.hide();
    };

    // edit click
    const editClick = () => {
      context.emit('edit', props.activityBudgetId);
    };

    // delete item
    const deleteClick = () => {
      swal.confirm('ลบข้อมูล!', 'คุณต้องการลบข้อมูลใช่หรือไม่?', 'ใช่ ลบเดี๋ยวนี้!', '#dc3545')
        .then((result) => {
          if (result.isConfirmed) {
            store.dispatch(ActivityBudgetAction.DELETE, {
                activityId: props.activityId,
                provinceId: props.provinceId,
                id: props.activityBudgetId
              })
                .then(() => {
                  context.emit('deleted');
                  hide();
                });
          }
        });
    };

    const thaiDate = (date: Date) =>
      dateFormat.toThaiDate(date, 'long');

    return {
      activityBudget,
      activityBudgetOffcanvas,
      show,
      hide,
      editClick,
      deleteClick,
      thaiDate,
    };
  },
});
